// extracted by mini-css-extract-plugin
module.exports = {"inCharge":"_3wzZc6aPIpBqBmuEH83Poo"};